import React from 'react'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { Game } from 'protos'

import T from 'components/FormattedMessage'

import GameCardBottomInfoBar from '../GameCardBottomInfoBar'

interface Props {
  progress?: Game.IClassicProgress | null
}

const styles = createStyles({
  status: {
    fontSize: 10,
    fontWeight: 500,
    textTransform: 'uppercase',
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardBottomInfoBarLive: React.SFC<InjectedProps> = ({
  classes,
  progress,
}) => {
  const total = progress?.matchCount ?? 0
  const started = progress?.matchesStarted ?? 0

  return (
    <GameCardBottomInfoBar>
      <Grid alignItems="center" justify="center" direction="row" container>
        <Grid item>
          <Typography className={classes.status}>
            {total < 2 ? (
              <T
                id="game_classic_matchcount_singular"
                values={{ total, started }}
              />
            ) : (
              <T
                id="game_classic_matchcount_plural"
                values={{ total, started }}
              />
            )}
          </Typography>
        </Grid>
      </Grid>
    </GameCardBottomInfoBar>
  )
}

export default withStyles(styles)(GameCardBottomInfoBarLive)
